import React, { useEffect, useState } from "react";

import PaginationFull from "../generic-ui/PaginationFull";
import Select from "../generic-ui/Select";
import { useDispatch, useSelector } from "react-redux";
import { startLoadingCatalogsAll } from "../../app/actions/catalogActions";
import { startLoadingContinents } from "../../app/actions/continentActions";
import { startLoadingRegions } from "../../app/actions/regionActions";
import { startLoadingCountries } from "../../app/actions/countryActions";
import L4CardVision from "./L4CardVision";
import IntegrationSearchChrome from "./IntegrationSearchChrome";
import { debugLogPages } from "../../app/helpers/debugHelper";

const listOptions = [3, 6, 9, 12, 15, 18, 21, 30, 60, 90, 100];

const L3ContainerVision = ({ data, totalPagesS, totalItemsS, currentPageS, onChangeSelect, onPageChange, itemsPerPage, moduleSelected }) => {

  debugLogPages(':: L3ContainerVision');

  const dispatch = useDispatch();

  const { listFieldsVision } = useSelector((state) => state.moduleConfig);
  const [, setCountCompareTechInContainer] = useState(0);
  const [, setListFieldsToCompare] = useState();

  useEffect(() => {
    let listFieldsToCompareT = [];
    listFieldsVision.forEach(element => {
      
      if (element.is_comparable) {
        
        listFieldsToCompareT.push(element);
      }
    });
    setListFieldsToCompare(listFieldsToCompareT);
  }, [])

  useEffect(() => {
    dispatch(startLoadingCatalogsAll());
    dispatch(startLoadingContinents());
    dispatch(startLoadingRegions());
    dispatch(startLoadingCountries());
  }, [])


  return (
    <div>
      <ul className="cards">
        {data && data.length > 0 && data.map((tec, index) => (
          <L4CardVision
            key={tec.id}
            data={tec}
            index={index}
            setCountCompareTechInContainer={setCountCompareTechInContainer}
            moduleSelected={moduleSelected}
          />
        ))}
      </ul>

      {data && data.length > 0 && (
        <div>
          <Select
            listOptions={listOptions}
            onChangeSelect={onChangeSelect}
            
            pageSize={itemsPerPage}
          />
        </div>
      )}

      <div className="pagination justify-content-center">
        {/*<Pagination
          totalPages={totalPagesS}
          totalItems={totalItemsS}
          currentPage={currentPageS + 1}
          itemsPerPage={itemsPerPage}
          onPageChange={onPageChange}
      />*/}

        <PaginationFull
          totalRecords={totalItemsS}
          itemsPerPage={itemsPerPage}
          pageNeighbours={2}
          onPageChange={onPageChange}
          currentPage={currentPageS + 1}
          totalPages={totalPagesS}
        />
      </div>

      <hr />
      <br />

      <IntegrationSearchChrome
        hasResults={data && data.length > 0}
        moduleSelected={moduleSelected}
        showComparison={false}
      />

    </div>
  );
};

export default L3ContainerVision;
